import L from 'leaflet';
import * as esri from 'esri-leaflet';
import { CobMarker, MapLayer, TableData, LegendSection } from '../types';
export module CobMap {
  export class FeatureLayerService {
    featureLayer: esri.FeatureLayer;
    map: L.Map;
    mapLayer: MapLayer;
    hasLegendItems: boolean;
    legendItems: LegendSection;

    constructor(flayer: esri.FeatureLayer, myMap: L.Map, mlayer: MapLayer) {
      this.featureLayer = flayer;
      this.map = myMap;
      this.mapLayer = mlayer;
      this.hasLegendItems = false;
      this.legendItems = { id: '', name: '', items: [] };
    }

    getLegendItems(
      callback: (legend: LegendSection, error: string) => any
    ): void {
      var vm = this;
      if (vm.mapLayer.includeLegend) {
        this.featureLayer.metadata(function(error: any, metadata: any) {
          if (
            metadata &&
            metadata.drawingInfo &&
            metadata.drawingInfo.renderer
          ) {
            vm.legendItems.id = vm.mapLayer.id;
            //fix metadataname
            vm.legendItems.name = vm._cleanTitle(metadata.name);

            if (metadata.drawingInfo.renderer.uniqueValueInfos) {
              var uniqueItems = metadata.drawingInfo.renderer.uniqueValueInfos;

              for (var i = 0; i < uniqueItems.length; i++) {
                var item = uniqueItems[i];
                if (vm.mapLayer.style) {
                  item.symbol.color = vm.mapLayer.style.color
                    ? vm._hexToRgba(vm.mapLayer.style.color)
                    : item.symbol.color;
                  item.symbol.width = vm.mapLayer.style.weight
                    ? vm.mapLayer.style.weight
                    : item.symbol.width;
                }
                if (
                  (vm.mapLayer.legendFilter &&
                    item.value == vm.mapLayer.legendFilter) ||
                  !vm.mapLayer.legendFilter
                ) {
                  vm.legendItems.items.push(item);
                }
              }
            } else if (metadata.drawingInfo.renderer.symbol) {
              var sitem = metadata.drawingInfo.renderer;
              sitem.value = '';
              sitem.label = '';
              if (vm.mapLayer.style) {
                sitem.symbol.color = vm.mapLayer.style.fillColor
                  ? vm._hexToRgba(vm.mapLayer.style.fillColor)
                  : sitem.symbol.color;
                sitem.symbol.width = vm.mapLayer.style.weight
                  ? vm.mapLayer.style.weight
                  : sitem.symbol.width;
              }

              vm.legendItems.items.push(sitem);
            }
            return callback(vm.legendItems, '');
          }
        });
      } else {
        return callback(vm.legendItems, '');
      }
    }

    //add labels
    addLabels() {
      var vm = this;
      let labels: any = {};
      if (vm.mapLayer.addLabels && vm.mapLayer.labelPropertyName) {
        vm.featureLayer.on('createfeature', function(e: any) {
          var id = e.feature.id;
          var property = e.feature.properties[vm.mapLayer.labelPropertyName];
          var feature = vm.featureLayer.getFeature(id);
          if (feature) {
            //@ts-ignore
            var center = feature.getBounds().getCenter();
            var label = L.marker(center, {
              icon: L.divIcon({
                className: 'label',
                html: '<h3>' + property + '</h3>'
              }),
            }).addTo(vm.map);
            labels[id] = label;
          }
        });
      }
    }
    //fitbounds
    fitBounds() {
      var vm = this;
      let featureCount = 0;
      let bounds = L.latLngBounds([]);
      if (vm.mapLayer.fitBounds) {
        //@ts-ignore
        vm.featureLayer.once('load', function(evt: any) {
          featureCount++;
          // create a new empty Leaflet bounds object
          bounds = L.latLngBounds([]);
          // loop through the features returned by the server
          //@ts-ignore
          vm.featureLayer.eachFeature(function(layer: any) {
            // get the bounds of an individual feature
            if (layer.getBounds != undefined) {
              var layerBounds = layer.getBounds();
              // extend the bounds of the collection to fit the bounds of the new feature
              bounds.extend(layerBounds);
            } else {
              bounds.extend(layer.getLatLng());
            }
          });

          if (featureCount > 0 && bounds.isValid() && vm.map) {
            vm.map.fitBounds(bounds);
          }
        });
      }
    }

    private _cleanTitle(name: string) {
      var newName = name.replace('_', ' ');
      return newName;
    }

    private _hexToRgba(hex: string) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
            255,
          ]
        : null;
    }
  }
}
